<template>
  <div>
    <document-upload-button
      :required="field.required"
      v-model="value"
      :rules="validationRules"
      @uploading="$emit('toggle-confirm-button', true)"
      @uploaded="$emit('toggle-confirm-button', false)"></document-upload-button>
    <span class="text-caption">
      <i18n-t
        keypath="customForms.messages.maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload">
        <template #size><strong>50MB</strong></template>
        <template #imageLimit>
          <strong>{{ $t('customForms.messages.oneImage') }}</strong>
        </template>
        <template #typeLimitText>
          <strong>{{ $t('global.basicTerms.text') }}</strong>
        </template>
        <template #typeLimitZip>
          <strong>{{ $t('global.basicTerms.zip') }}</strong>
        </template>
        <template #typeLimitSpreadsheet>
          <strong>{{ $t('global.basicTerms.spreadsheet') }}</strong>
        </template>
      </i18n-t>
    </span>
  </div>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';

export default {
  name: 'custom-field-document',
  mixins: [customFieldTypeMixin]
};
</script>
